/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { ParticipantDTO } from "./participant-dto";

export class Participant {

    public ID: string;
    public name: string;
    public targetURL: string;
    public supportedProtocols: string[];

    constructor(
        ID: string,
        name: string,
        targetURL: string,
        supportedProtocols: string[]
    ) {
        this.ID = ID;
        this.name = name;
        this.targetURL = targetURL;
        this.supportedProtocols = supportedProtocols;
    }

    public static createFromDTO(dto: ParticipantDTO): Participant {
        return new Participant(
            dto.id,
            dto.name,
            dto.targetUrl,
            dto.supportedProtocols
        );
    }

}